// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__JKMrK","title":"Info_title__1LCbV","selects":"Info_selects__j8lRq","requiredAsterisk":"Info_requiredAsterisk__1ME-t"};